export const runWithTiming = async ({ step, updateProgress, task }) => {
  const t0 = performance.now();

  updateProgress(step, "en_progreso", 0);
  await new Promise(r => setTimeout(r, 150));

  await task();

  const tiempo = performance.now() - t0;

  updateProgress(step, "completado", 100, tiempo);
};
